import React, { useEffect } from "react";
import "../../css/components/popups/AutoClosePopup.css";

export const TitleType = {
    SUCCESS: "success",
    ERROR:   "error",
    WARNING: "warning",
    INFO:    "info",
};
export const popupConfig = {
    [TitleType.SUCCESS]: { icon: "✓", color: "#22c55e" },
    [TitleType.ERROR]:   { icon: "✕", color: "#ef4444" },
    [TitleType.WARNING]: { icon: "!", color: "#f59e0b" },
    [TitleType.INFO]:    { icon: "i", color: "#3b82f6" },
};

const AutoClosePopup = ({
    isOpen,
    onClose,
    type = "",
    duration = 5,
    title = "Alert",
    children,
}) => {
    const config = popupConfig[type] || popupConfig.info;

    useEffect(() => {
        if (!isOpen) return;

        const timeoutId = setTimeout(() => {
            onClose();
        }, duration * 1000);

        return () => clearTimeout(timeoutId);
    }, [isOpen, duration, onClose]);

    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-container">
                <div className="popup-header">
                    <div className="popup-title">
                        <div
                            className="popup-icon"
                            style={{ backgroundColor: config.color }}
                        >
                            {config.icon}
                        </div>

                        <h3>{title}</h3>
                    </div>

                    <button
                        className="popup-close"
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>

                <div className="popup-body">
                    {children}
                </div>

                <div className="popup-footer">
                    <button
                        className="popup-btn"
                        onClick={onClose}
                    >
                        Close
                    </button>

                    <div className="countdown-bar">
                        <div
                            key       = { isOpen ? Date.now() : "closed" }
                            className = "countdown-fill"
                            style     = {{
                                background: config.color,
                                animationDuration: `${duration}s`,
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AutoClosePopup;
